/**
 * Helper-Funktionen für Kontaktformular-Optionen
 * Wandelt interne Werte in lesbare Labels um
 */

export interface ContactFormData {
  name: string
  email: string
  interest?: string
  projectType?: string
  budget?: string
  message: string
}

// Interessensgebiete Mapping
export const INTEREST_LABELS: Record<string, string> = {
  wordpress: 'WordPress Development',
  webdev: 'Webentwicklung (Vue, React, TypeScript)',
  'custom-tools': 'Custom Tools & Lösungen',
  consulting: 'Allgemeine Beratung',
  other: 'Sonstiges'
}

// Projekttyp Mapping
export const PROJECT_TYPE_LABELS: Record<string, string> = {
  new: 'Neues Projekt starten',
  extend: 'Bestehendes Projekt erweitern',
  support: 'Fehlerbehebung / Support',
  consulting: 'Beratung / Konzept',
  other: 'Sonstiges'
}

// Budget Mapping
export const BUDGET_LABELS: Record<string, string> = {
  'under-1k': 'Unter 1.000 €',
  '1k-5k': '1.000 € - 5.000 €',
  '5k-10k': '5.000 € - 10.000 €',
  '10k-25k': '10.000 € - 25.000 €',
  'over-25k': 'Über 25.000 €',
  unclear: 'Noch unklar'
}

/**
 * Gibt das ausgeschriebene Label für ein Interessensgebiet zurück
 */
export const getInterestLabel = (value: string | undefined): string => {
  if (!value) return '-'
  return INTEREST_LABELS[value] || value
}

/**
 * Gibt das ausgeschriebene Label für einen Projekttyp zurück
 */
export const getProjectTypeLabel = (value: string | undefined): string => {
  if (!value) return '-'
  return PROJECT_TYPE_LABELS[value] || value
}

/**
 * Gibt das ausgeschriebene Label für ein Budget zurück
 */
export const getBudgetLabel = (value: string | undefined): string => {
  if (!value) return '-'
  return BUDGET_LABELS[value] || value
}

/**
 * Formatiert Kontaktformular-Daten für die Anzeige
 */
export const formatContactData = (data: ContactFormData) => {
  return {
    ...data,
    interestLabel: data.interest ? getInterestLabel(data.interest) : null,
    projectTypeLabel: data.projectType ? getProjectTypeLabel(data.projectType) : null,
    budgetLabel: data.budget ? getBudgetLabel(data.budget) : null
  }
}









